import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ValueProposition = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('valuePropositionTitle')}</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">{t('valuePropositionSubtitle')}</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className={`bg-gradient-to-r from-blue-50 to-blue-50 p-6 rounded-xl ${isRTL ? 'border-r-4' : 'border-l-4'} border-blue-600 staggered-animation`}>
              <h3 className={`text-xl font-semibold text-blue-800 mb-3 ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? '💰 وفورات لا تُقاوم في التكاليف' : '💰 Unbeatable Cost Savings'}
              </h3>
              <p className={`text-lg text-gray-700 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? (
                  <>
                    <strong>وظف مساعدك القانوني الذكي بـ 2,000 درهم إماراتي فقط</strong>، توفر عليك من 10,000 إلى 85,000 درهم إماراتي مقارنة بالرسوم القانونية التقليدية. راجع العقود في دقائق، وليس أيام. قلل الأخطاء البشرية المحتملة، تأخير المشاريع، وافهم مخاطرك القانونية والمالية.
                  </>
                ) : (
                  <>
                    <strong>Hire your AI legal assistant for just AED 2,000</strong>, saving you AED 10,000 to AED 85,000 compared to traditional legal fees. Review contracts in minutes, not days. Reduce human potential errors, project delays, and understand your legal and financial risks.
                  </>
                )}
              </p>
            </div>
            
            <div className={`bg-gradient-to-r from-green-50 to-green-50 p-6 rounded-xl ${isRTL ? 'border-r-4' : 'border-l-4'} border-green-400 staggered-animation`}>
              <h3 className={`text-xl font-semibold text-green-800 mb-3 ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? '🚀 تخفيض 95% في التكلفة للمحامين' : '🚀 95% Cost Reduction for Lawyers'}
              </h3>
              <p className={`text-green-800 font-medium ${isRTL ? 'text-right' : 'text-left'}`}>
                {isRTL ? 
                  'يمكن للمحامين توفير الوقت وتقليل التكاليف بنسبة 95% مع الذكاء الاصطناعي المدرب على معايير FIDIC، العقود المخصصة، القوانين المدنية، وقوانين الشراء المحلية.' :
                  'Lawyers can save time and reduce costs by 95% with AI trained on FIDIC standards, customized contracts, Civil Codes, and local procurement laws.'
                }
              </p>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 p-8 rounded-2xl text-white staggered-animation">
            <div className="text-center">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-calculator text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">
                {isRTL ? 'مقارنة التكاليف' : 'Cost Comparison'}
              </h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-white/10 rounded-lg">
                  <span className="text-white/90">{isRTL ? 'مراجعة قانونية تقليدية' : 'Traditional Legal Review'}</span>
                  <span className="text-xl font-bold text-red-300">{isRTL ? '١٠,٠٠٠ - ٨٥,٠٠٠ درهم' : 'AED 10,000 - 85,000'}</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-white/10 rounded-lg">
                  <span className="text-white/90">{isRTL ? 'مراجعة الجيلاني بالذكاء الاصطناعي' : 'Jelani AI Review'}</span>
                  <span className="text-xl font-bold text-green-300">{isRTL ? '٢,٠٠٠ درهم' : 'AED 2,000'}</span>
                </div>
                <div className="text-center pt-4">
                  <div className="text-3xl font-bold text-green-300">{isRTL ? 'وفر حتى ٩٨٪' : 'Save up to 98%'}</div>
                  <div className="text-sm text-white/80">{isRTL ? 'لكل مراجعة عقد' : 'Per contract review'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
